import styled from '@emotion/styled';

import { darkGrey, fontWeight } from '~/styles';

export const H3 = styled.h3`
  font-size: 13px;
  font-weight: ${fontWeight.medium};
  letter-spacing: 1px;
  color: ${darkGrey};
  margin: 0;
`;
